// Single switch for every CTA button.
// "early-access" opens the signup modal. Later: set mode "link" and REACT_APP_KEEPTHIS_APP_URL to send visitors to the app.
export const CTA_CONFIG = {
  mode: "early-access",
  href: process.env.REACT_APP_KEEPTHIS_APP_URL || "",
  label: "Get Early Access",
};

// Keep subscription pricing hidden until plans are final.
export const SHOW_PRICING = false;
